import React, { useEffect, useState, useCallback } from 'react';
import { ChevronUp, Headphones } from 'lucide-react';

export const ScrollButtons: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);

    const checkScroll = useCallback(() => {
        const root = document.getElementById('root');
        if (!root) return;

        const st = root.scrollTop;

        // Use very stable hysteresis
        setIsVisible(prev => {
            if (!prev && st > 600) return true;
            if (prev && st < 300) return false;
            return prev;
        });
    }, []);

    useEffect(() => {
        const root = document.getElementById('root');
        if (!root) return;

        let ticking = false;
        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    checkScroll();
                    ticking = false;
                });
                ticking = true;
            }
        };

        root.addEventListener('scroll', onScroll, { passive: true });
        checkScroll();

        return () => root.removeEventListener('scroll', onScroll);
    }, [checkScroll]);

    const scrollToTop = () => {
        const root = document.getElementById('root');
        if (root) {
            window.Telegram?.WebApp?.HapticFeedback?.impactOccurred('light');
            root.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const scrollToBottom = () => {
        const root = document.getElementById('root');
        if (root) {
            window.Telegram?.WebApp?.HapticFeedback?.impactOccurred('light');
            root.scrollTo({ top: root.scrollHeight, behavior: 'smooth' });
        }
    };

    return (
        <div
            className={`fixed bottom-28 right-5 z-[200] flex flex-row-reverse gap-3 pointer-events-none transition-all duration-300 ease-in-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
        >
            <button
                onClick={scrollToTop}
                className="glass-strong w-12 h-12 rounded-2xl flex items-center justify-center text-white pointer-events-auto active:scale-90 transition-all shadow-2xl border border-white/10"
                style={{ WebkitTapHighlightColor: 'transparent' }}
            >
                <ChevronUp size={24} strokeWidth={2.5} />
            </button>

            <button
                onClick={scrollToBottom}
                className="glass-strong w-12 h-12 rounded-2xl flex items-center justify-center text-white pointer-events-auto active:scale-90 transition-all shadow-lg shadow-blue-500/30 border border-blue-500/30"
                style={{ WebkitTapHighlightColor: 'transparent' }}
            >
                <Headphones size={24} />
            </button>
        </div>
    );
};
